var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSunnyWindy = function SvgSunnyWindy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "sunny-windy_svg__Light",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sunny-windy_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 18h13M3.5 20h13M.5 22h13M20.076 19.029a3.435 3.435 0 0 0 1.754-6.382 2.66 2.66 0 0 0-2.776-3.518 4.562 4.562 0 0 0-8.869 1.508A4.194 4.194 0 0 0 6 14.833M5.628 10.5A3.5 3.5 0 0 1 10.5 5.628M8.5 3V2M4.611 4.611l-.707-.707M3 8.5H2M4.611 12.389l-.707.707M13.096 3.904l-.707.707",
    className: "sunny-windy_svg__cls-1"
  })));
};
export default SvgSunnyWindy;